module.exports = __webpack_public_path__ + "a734d381ec8523a76ee842038e6f2b87.svg";